import { Messages } from '~src/codegen/Localize';

import { RegexBasedPasswordPolicy } from './RegexBasedPasswordPolicy';

export class MustContainNumbersPolicy extends RegexBasedPasswordPolicy {

    private static instance: MustContainNumbersPolicy = new MustContainNumbersPolicy();

    private constructor() {
        super(/[0-9]/);
    }

    public static getPolicy(): MustContainNumbersPolicy {
        return MustContainNumbersPolicy.instance;
    }

    public getErrorMessage(): string {
        return Messages.passwordPolicies_mustContainNumbers();
    }

    public getTestId(): string {
        return MustContainNumbersPolicy.name;
    }
}
